import { useState } from "react";
import "./Register.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faScaleBalanced,
  faUser,
  faEnvelope,
  faPhone,
  faLock,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import base_url from "../api";

const Register = () => {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    agree: false,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (form.password !== form.confirmPassword) {
      return setError("Passwords do not match");
    }

    if (!form.agree) {
      return setError("You must agree to the terms and privacy policy");
    }

    setLoading(true);

    try {
      // Prepare payload (exclude confirmPassword and agree from API call)
      const payload = {
        firstName: form.firstName,
        lastName: form.lastName,
        email: form.email,
        phone: form.phone,
        password: form.password,
        confirmPassword: form.confirmPassword,
        agree: form.agree,
      };

      const res = await fetch(`${base_url}/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data.message || "Registration failed");

      console.log("Account created:", data);
      setError("");
      setSuccess("Registration successful! Check your email to activate your account.");
      setForm({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        password: "",
        confirmPassword: "",
        agree: false,
      });
    } catch (err) {
      setError(err.message || "Failed to register. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="register-section">
      <div className="register-overlay" />

      <div className="register-wrapper">
        {/* Logo */}
        <div className="login-logo">
          <FontAwesomeIcon icon={faScaleBalanced} />
          <div>
            <h3>Sandy Randhawa</h3>
            <span>Family Law Solicitor</span>
          </div>
        </div>

        {/* Card */}
        <div className="register-card">
          <h2>Create Your Account</h2>
          <p className="register-sub">
            Get started with your client portal to manage your case
          </p>

          <form onSubmit={handleSubmit}>
            {/* Name */}
            <div className="form-row">
              <div className="input-group">
                <FontAwesomeIcon icon={faUser} />
                <input
                  name="firstName"
                  placeholder="First name"
                  value={form.firstName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="input-group">
                <FontAwesomeIcon icon={faUser} />
                <input
                  name="lastName"
                  placeholder="Last name"
                  value={form.lastName}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* Email */}
            <div className="input-group">
              <FontAwesomeIcon icon={faEnvelope} />
              <input
                type="email"
                name="email"
                placeholder="your@email.com"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>

            {/* Phone */}
            <div className="input-group">
              <FontAwesomeIcon icon={faPhone} />
              <input
                name="phone"
                placeholder="01900 123456"
                value={form.phone}
                onChange={handleChange}
              />
            </div>

            {/* Password */}
            <div className="form-row">
              <div className="input-group">
                <FontAwesomeIcon icon={faLock} />
                <input
                  type="password"
                  name="password"
                  placeholder="Create password"
                  value={form.password}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="input-group">
                <FontAwesomeIcon icon={faLock} />
                <input
                  type="password"
                  name="confirmPassword"
                  placeholder="Confirm password"
                  value={form.confirmPassword}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* Agree */}
            <div className="agree-row">
              <label>
                <input
                  type="checkbox"
                  name="agree"
                  checked={form.agree}
                  onChange={handleChange}
                />{" "}
                I agree to the <span>Terms & Conditions</span> and{" "}
                <span>Privacy Policy</span>
              </label>
            </div>

            {error && <p className="error">{error}</p>}
          {success && <p className="success">{success}</p>}

            <button className="register-btn" disabled={loading}>
              {loading ? "Creating..." : "Create Account"}
              <FontAwesomeIcon icon={faArrowRight} />
            </button>
          </form>

          <p className="login-link">
            Already have an account? <Link to="/login">Sign in</Link>
          </p>

          <div className="back-link">← Back to website</div>
        </div>

        <p className="register-note">
          Your information is protected and confidential
        </p>
      </div>
    </section>
  );
};

export default Register;
